import { Component, ViewContainerRef, ViewChild } from "@angular/core";
import { IFloatingFilterComp } from "ag-grid-angular";
import { IFloatingFilterParams, FilterChangedEvent } from "ag-grid-community";

@Component({
  selector: "app-text-floating-filter",
  templateUrl: "./text-floating-filter.component.html",
  styleUrls: ["./text-floating-filter.component.css"],
})
export class TextFloatingFilterComponent implements IFloatingFilterComp {
  public text: string; // need to be public for --prod compile
  private params: IFloatingFilterParams<any, any>;
  customId = String(Math.random() * (13904.4953 - 1039.39402) + 4.9);

  agInit(params: IFloatingFilterParams<any, any>): void {
    this.params = params;
    this.text = "";
  }

  onChange(newValue: string) {
    if (this.text !== newValue) {
      this.text = newValue;
      this.params.onFloatingFilterChanged(this.text);
    }
  }

  getGui(): any {}

  onParentModelChanged(parentModel) {
    this.text = parentModel.value;
  }
}
